import BaseError, { ErrorProps } from './BaseError';

export function DefaultError(props: ErrorProps) {
  return (
    <BaseError
      description="We are sorry for the inconvenience. Please try again later."
      title="Something Went Wrong"
      {...props} />
  );
}
